import { NAME as ROOT_NAME } from '../constants';

export const NAME = `${ROOT_NAME}/ACCOUNT_MANAGEMENT`;
